<template>
  <div class="scene-plot">
    <div class="back-button">
      <img src="/images/game/back.png" @click="handleBack" />
    </div>

    <img class="sprite" src="/images/game/sprite-3.png" />

    <div class="dialog">
      <div class="content-1" v-show="step !== 2" @click="handleClick">
        <span class="typing-text">
          <TypingText :width="350" :height="60" :text.sync="content" @end="handleEnd" />
        </span>
        <!-- <i class="caret"></i> -->
      </div>
      <div class="content-2" v-show="step === 2">
        <div class="title">{{content}}</div>
        <input type="text" v-model="nickname" placeholder="请输入您的名字" />
        <input type="button" value="确定" @click="submit" />
      </div>
    </div>
  </div>
</template>

<script>
import TypingText from "../common/TypingText";
import BackButton from "../common/BackButton";

export default {
  name: "PlotScene",
  components: {
    TypingText,
    BackButton
  },
  data() {
    return {
      step: 0,
      content: "",
      nickname: ""
    };
  },
  computed: {
    username: function() {
      return this.$store.state.sys.sysUser.me.username;
    },
    nickName: function() {
      return this.$store.state.sys.sysUser.me.nickName;
    }
  },
  created() {
    this.$emit("changeBackgroundMusic", "/music/主背景音乐（场景2、3、4）.mp3");
  },
  mounted() {
    this.incr();
  },
  updated() {
    // this.typing();
  },
  methods: {
    typing() {
      this.$emit("changeForegroundMusic", "/music/打字.mp3", true);
      const box = document.getElementsByClassName("typing-text")[0];

      console.log(box);
      const str = box.innerText;

      let i = 0;
      box.innerText = "";

      const self = this;
      const typing = setInterval(function() {
        box.innerText += str[i++];
        if (i >= str.length) {
          clearInterval(typing);
          self.$emit("changeForegroundMusic", "/music/打字.mp3", false);
          self.incr();
        }
      }, 200);
    },
    startTyping() {
      const length = this.content.length;
      const lines = length / 24 + 1;
    },
    endTyping() {},
    incr() {
      this.step++;

      switch (this.step) {
        case 1:
          this.content =
            "Bonjour！我是小悦，是咏悦汇葡萄酒世界的第二代精灵守护者~（咧嘴笑）";
          break;
        case 2:
          this.content = `亲爱的${this.username}，你叫什么名字？（咧嘴笑）`;
          break;
        case 3:
          this.content = `Bravo~${this.nickName}，你一定是母亲大人派来帮助小悦重拾葡萄酒精灵力量的！（坚定）`;
          break;
        case 4:
          this.content =
            "我的母亲是咏悦汇葡萄酒世界的精灵女王，她曾经守护着这里的每一颗葡萄，用精灵力量将一颗颗的酿酒葡萄变为琼浆玉露的葡萄酒，可是…2020 年 1 月，冠状魔王袭击了葡萄酒世界，母亲大人也在这场战斗中离开了她最爱的小葡萄们…乌云笼罩，狂风暴雨…（悲伤）";
          break;
        case 5:
          this.content =
            "母亲大人说，会有智慧的使者帮助我，获得葡萄精灵力量，让每一颗葡萄有最温柔的关照，重建我们的家园，让咏悦汇葡萄酒世界散发光芒！（坚定）";
          break;
        case 6:
          this.content = `亲爱的${this.nickName}，接下来请和我一起，完成挑战，获得葡萄酒精灵力量！（咧嘴笑）`;
          break;
        case 7:
          this.content = `噢对了！完成挑战后，为了感谢亲爱的${this.nickName}，小悦也将送上一瓶神秘的葡萄酒作为礼品！加油吧~（咧嘴笑）`;
          break;
        case 8:
          this.$emit("changeScene", "CheckpointPlotScene");
          break;
      }

      console.log(this.content);

      // this.typing();
    },
    handleEnd() {
      if (this.step === 2) {
        return;
      }

      setTimeout(this.incr, 2000);
    },
    handleClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.incr();
    },
    handleBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    },
    async submit() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      if (this.nickname) {
        const response = await this.ajax.doPost({
          packageName: "game",
          className: "common",
          methodName: "setMyNickName",
          params: {
            nickName: this.nickname
          }
        });

        await this.$store.dispatch("post", {
          packageName: "sys",
          className: "sysUser",
          methodName: "me",
          params: {}
        });

        this.incr();
      }
    }
  }
};
</script>


<style lang="scss" scoped>
@keyframes ani {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.scene-plot {
  width: 1100px;
  height: 560px;
  position: relative;

  background-image: url(/images/game/plot-background.png);
  background-size: cover;
  animation: ani 1.5s;

  .back-button {
    position: absolute;
    width: 80px;
    height: 40px;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  @keyframes spritemove {
    from {
      left: -385px;
    }

    to {
      left: 90px;
    }
  }

  .sprite {
    position: absolute;
    top: 76px;
    left: 90px;
    width: 385px;
    height: 403px;

    animation: spritemove 2s;

    // animation: hu__hu__ infinite 2s ease-in-out;
  }

  @keyframes hu__hu__ {
    50% {
      transform: translateY(20px);
    }
  }

  .caret::after {
    content: "";
    display: inline-block;
    width: 2px;
    height: 1em;
    margin-bottom: -2px;
    margin-left: -2px;
    background-color: #333;
    animation: blink-caret 0.5s step-end infinite;
  }
  @keyframes blink-caret {
    50% {
      opacity: 0;
    }
  }

  .dialog {
    position: absolute;
    top: 161px;
    left: 464px;
    width: 482px;
    height: 230px;

    background: url(/images/game/dialog-background.png);
    background-size: cover;

    .content-1 {
      width: 350px;
      height: 60px;
      padding: 30px 38px 70px 86px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
    }

    .content-2 {
      padding: 30px 95px 30px 115px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;

      text-align: center;

      .title {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 24px;
      }

      input[type="text"] {
        margin: 15px 0;
        width: 270px;
        height: 14px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(0, 0, 0, 1);
        padding: 18px;
      }

      input[type="button"] {
        width: 130px;
        height: 44px;
        background: linear-gradient(
          270deg,
          rgba(72, 72, 72, 1) 0%,
          rgba(30, 30, 30, 1) 100%
        );
        border: 3px solid;
        border-image: linear-gradient(
          270deg,
          rgba(90, 90, 90, 1),
          rgba(50, 50, 50, 1)
        );

        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 224, 168, 1);
        line-height: 40px;

        cursor: pointer;
      }
    }
  }
}
</style>